import { Directive, ElementRef, Injector } from '@angular/core';
import { UpgradeComponent } from '@angular/upgrade/static';

@Directive({selector: 'fbdn-accordion'}) // eslint-disable-line @angular-eslint/directive-selector
export class FbdnAccordionComponent extends UpgradeComponent {
   constructor(ref: ElementRef, inj: Injector) {
      super('fbdnAccordion', ref, inj);
   }
}
